export const ITEM_TEMPLATE = {
  itemName: '',
  expenseTypeCode: '',
  expenseTypeCodeDumb: '',
  itemUnitPriceTaxIn: 0,
  itemUnitPrice: 0,
  itemQuantity: 0,
  itemUnitOfQuantity: '',
  itemAmountTaxIn: 0,
  itemAmountTaxEx: 0,
  itemTax: 0,
  itemTaxType: '',
  itemDiscount: 0,
  itemCurrency: '',
  itemCurrencyN: '',
  itemDate: '',
  itemOrderNo: '',
  itemEtc: '',
}

export const ITEM_KEYS = Object.keys(ITEM_TEMPLATE)
